import { useState, useContext, useEffect } from "react";
import DataTable from "react-data-table-component";
import { getUsers } from "../../services/api";
import { AuthContext } from "../../App";

function Users() {
  const {
    settingsFormActive,
    setSettingsFormActive,
    setEvent,
    setSettingsForm,
    settingsForm,
  } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");

  console.log("load user component");

  const columns = [
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: "Client",
      selector: (row) => row.organisation_name,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row) => row.role,
      sortable: true,
    },
  ];

  const handleRowClicked = (event) => {
    console.log(event);
    setSettingsForm("user");
    setEvent(event);
    setSettingsFormActive(true);
  };

  useEffect(() => {
    getUsers().then(async (res) => {
      setData(res);
    });
  }, []);

  const handleSearch = (event) => {
    console.log(event.target.value);
    setSearchText(event.target.value);
  };

  const handleAddClick = () => {
    setSettingsForm("user");
    setSettingsFormActive(true);
  };

  const filteredData = data.filter((item) =>
    Object.keys(item).some(
      (key) =>
        item[key] !== null &&
        item[key].toString().toLowerCase().indexOf(searchText.toLowerCase()) >
          -1
    )
  );

  return (
    <div>
      <div className="settings-component-header">
        <input
          type="text"
          value={searchText}
          onChange={handleSearch}
          placeholder="Search"
          style={{
            marginLeft: 20,
            width: 300,
          }}
        />
        <button className="booking-button" onClick={handleAddClick}>
          add
        </button>
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover={true}
        striped={true}
        pointerOnHover={true}
        onRowClicked={(event) => handleRowClicked(event)}
        direction="auto"
        fixedHeader
        fixedHeaderScrollHeight="530px"
        persistTableHead
        responsive
        dense
      />
    </div>
  );
}

export default Users;
